export namespace ListInboundTypes {
    export enum Types {
        Entrepot = "entrepot",
        T1 = "t-1",
        Vrij = "vrij",
        AGP = "agp"
    }
}
